/**
 * @generated SignedSource<<f54b5b78ca914dcf8fb10dd1d0a0e97c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuthGate_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"auth_useAuthGate">;
  readonly " $fragmentType": "AuthGate_User";
};
export type AuthGate_User$key = {
  readonly " $data"?: AuthGate_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"AuthGate_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthGate_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "auth_useAuthGate"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3a361ba25cd80ee61737f4de548996fb";

export default node;
